import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { VNode } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPDropdownTransition',
  setup(__props) {



const setHeight = (item: Element): void => {
  // explicitly set height so that it can be transitioned
  ;(item as HTMLElement).style.height = `${item.scrollHeight}px`
}

const unsetHeight = (item: Element): void => {
  ;(item as HTMLElement).style.height = ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "vp-dropdown",
    onEnter: setHeight,
    onAfterEnter: unsetHeight,
    onBeforeLeave: setHeight
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})